import React from 'react';
import { useNavigateTo } from '../navigation/NavigationUtils';  // Gunakan named import
import './ErrorPage.css';

function ErrorPage() {

  const navigateTo = useNavigateTo();  // Menggunakan hook yang diimpor

  function handleBackToHome() {
    navigateTo('/');  // Panggil navigateTo untuk berpindah ke halaman Home
  }

  return (
    <div className="error-page-section">
      <div className="error-page-container" role="main" aria-labelledby="error-title" aria-describedby="error-desc">
        <h1 id="error-title" className="error-page-title">404</h1>
        <h2 className="error-page-sub-title">Halaman Tidak Ditemukan</h2>
        <p id="error-desc" className="error-page-sub-title">
          Maaf, halaman yang Anda cari tidak tersedia atau telah dipindahkan.
        </p>
        <button
          className="error-page-button"
          onClick={handleBackToHome}
          aria-label="Kembali ke Beranda"
        >
          Kembali ke Beranda
        </button>
      </div>
    </div>
  );
}

export default ErrorPage;
